import React from 'react';
import './FilterTabs.less';
import clsx from 'clsx';
import { FilterTabOption } from 'app/components/FilterTabs';

interface Props<T> {
  options: FilterTabOption<T>[];
  activeFilter: T;
  onChange: (value: T) => void;
}
export default function FilterTabs<T>({
  options,
  activeFilter,
  onChange,
}: Props<T>) {
  return (
    <div className="filter-tabs">
      {options.map(option => (
        <div
          key={option.label}
          className={clsx('filter-tabs__item', {
            'filter-tabs__item_active': activeFilter === option.value,
          })}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
}
